import { put, select, takeEvery } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import { getAuthToken } from '../../containers/Auth/selectors';
import { pageSynced } from '../../containers/PagesHistory/actions';
import { logError } from '../../utils/ErrorLogger';
import { triggerLegacyAppSync } from './actions';
import TasksQueue from './core/TasksQueue';

const tasksQueue = new TasksQueue({
  storageName: 'tasksQueue',
  tasksList: [],
});

tasksQueue.load();

function* syncOnAddWatcher() {
  try {
    const token = yield select(getAuthToken);

    const syncedPages = yield tasksQueue.start(token);

    for (const page of syncedPages) {
      yield put(pageSynced(page));
    }
  } catch (e) {
    logError(e);
  }
}

export default function* appSyncSaga() {
  yield takeEvery([getType(triggerLegacyAppSync)], syncOnAddWatcher);
}



// WEBPACK FOOTER //
// ./src/modules/appSync/saga.ts